import { render, staticRenderFns } from "./PuzzleListTable.vue?vue&type=template&id=0b29d45c&scoped=true&lang=html&"
import script from "./PuzzleListTable.vue?vue&type=script&lang=js&"
export * from "./PuzzleListTable.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleListTable.vue?vue&type=style&index=0&id=0b29d45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b29d45c",
  null
  
)

export default component.exports